/**
 * Séparations de chapitre — logique pure, sans dépendance.
 *
 * Une séparation lie deux containers : celui qui porte le masque (une colonne
 * dont le `maskId` désigne un masque `chapterSeparation`) et celui de son titre
 * lié (une box portant `linkedToMaskId`). Un seul des deux s'affiche, selon
 * `configuration.displayChapterSeparation`.
 *
 * Ce module est volontairement une feuille : `utils/containers.js`, qui
 * l'hébergeait, importe tout l'éditeur classique (store, composants) et ne peut
 * pas être chargé depuis le parser du web-editor.
 */

/**
 * Pour chaque paire liée par un masque de séparation de chapitre, l'id du
 * container du masque et celui de son container titre lié.
 */
export const getChapterSeparationContainerIds = ({ containers, boxes, columns, masks }) => {
  const chapterSepMaskIds = new Set(
    (masks || []).filter((m) => m.chapterSeparation).map((m) => m.id)
  );
  const chapterSepContainerIds = new Set();
  const linkedTitleContainerIds = new Set();

  for (const col of columns || []) {
    if (col.maskId && chapterSepMaskIds.has(col.maskId)) {
      const cont = containers.find((c) => c.columnsIds.includes(col.id));
      if (cont) chapterSepContainerIds.add(cont.id);
    }
  }
  for (const box of boxes || []) {
    if (box.linkedToMaskId) {
      const cont = containers.find((c) => c.columnsIds.includes(box.columnId));
      if (cont) linkedTitleContainerIds.add(cont.id);
    }
  }

  return { chapterSepContainerIds, linkedTitleContainerIds };
};

/**
 * Sous-ensemble des containers à afficher : le masque quand
 * `displayChapterSeparation` est vrai, le titre lié sinon.
 */
export const filterChapterSeparationContainers = ({
  containers,
  boxes,
  columns,
  masks,
  displayChapterSeparation,
}) => {
  const { chapterSepContainerIds, linkedTitleContainerIds } = getChapterSeparationContainerIds({
    containers,
    boxes,
    columns,
    masks,
  });

  return containers.filter((c) => {
    if (chapterSepContainerIds.has(c.id) && !displayChapterSeparation) return false;
    if (linkedTitleContainerIds.has(c.id) && displayChapterSeparation) return false;
    return true;
  });
};
